export default "__VITE_ASSET__BSuGd0dw__"